import produce from 'immer';
import {
  ENABLE_MOUSE_CONTROLS,
  INIT_USER_DATA,
  INIT_USER_DATA_SUCCESS,
  INIT_USER_DATA_ERROR,
  SET_MENU_ITEMS,
} from './action-types';

const initialState = {
  mouseControlsEnabled: false,
  onUserDataInit: true,
  menu: [],
  screens: [],
};

export type AppStateType = typeof initialState;

export default produce((draft: AppStateType, action) => {
  switch (action.type) {
    case ENABLE_MOUSE_CONTROLS:
      const { mouseControlsEnabled } = action.payload;
      draft.mouseControlsEnabled = mouseControlsEnabled;
      break;
    case INIT_USER_DATA:
      draft.onUserDataInit = true;
      break;
    case INIT_USER_DATA_SUCCESS:
    case INIT_USER_DATA_ERROR:
      draft.onUserDataInit = false;
      break;
    case SET_MENU_ITEMS: {
      draft.menu = action.payload;
      break;
    }
    default:
    // nothing
  }
}, initialState);
